import { ySyncPluginKey } from 'y-prosemirror';
import { Transaction } from 'yjs';

export default function getYSyncKey(transaction: Transaction): boolean {
  const $index = (ySyncPluginKey as any).key.indexOf('$');
  const ysyncKey = (ySyncPluginKey as any).key.substring(0, $index + 1);
  return Object.keys(transaction.meta ?? {}).some((key) => key.startsWith(ysyncKey));
}
